<template>
    <div class="variant-item" :class="{ 'variant-item--active': isActive, 'variant-item--dense': dense }">
        <div class="row m-0">
            <div class="variant-item__title col">
                <slot name="title"></slot>
            </div>

            <div v-if="$slots.price" class="variant-item__price col-auto p-0">
                <slot name="price"></slot>
            </div>
        </div>

        <div class="row m-0 flex-grow-1">
            <div v-if="$slots.subtitle" class="variant-item__subtitle col">
                <slot name="subtitle"></slot>
            </div>

            <div v-if="$slots.hint" class="variant-item__hint col-auto p-0 mt-1">
                <slot name="hint"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Discount from '@/components/checkout/Discount.vue';

export default {
    name: 'VariantItem',
    components: { Discount },

    props: {
        isActive: Boolean,
        dense: Boolean
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/_mixins.scss';
@use '@/styles/theming' as *;

.variant-item {
    $price-width: 120px;
    $price-height-normal: 44px;
    $price-height-dense: 34px;
    $self: &;

    display: flex;
    flex-direction: column;
    border: 1px solid variables.$variant-select-border-color;
    position: relative;
    margin: -1px;
    text-decoration: none;
    cursor: pointer;
    color: var(--product-select-variant-color);

    // prevents from readonly items (additional feature) shadow
    @media (hover: hover) {
        &:hover {
            box-shadow: 0 5px 18px 0 hsla(0, 0%, 0%, 0.16);
        }
    }

    &__title,
    &__subtitle {
        flex-grow: 1;
        padding: 8px 10px 8px 15px;
    }

    &__title {
        font-size: 16px;
        font-weight: 900;
        line-height: 19px;
        min-height: $price-height-normal;
    }

    &__subtitle {
        padding-top: 0;
        font-size: 15px;
        line-height: 22px;
        display: flex;

        margin-top: -10px; //questionable. With price blocks of 44 px prevents from being to distant from title
    }

    &__price,
    &__hint {
        flex: 0 0 120px;
        width: auto;
        max-width: 100%;
        margin-left: auto;
    }

    &__price {
        background-color: var(--product-select-variant-price-bg);
        color: var(--product-select-variant-price-color);
        z-index: 1;
        align-self: start;
        height: $price-height-normal;

        ::v-deep .price {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            height: 100%;
            line-height: 1;
            padding-top: 2px;
            padding-bottom: 2px;
        }

        ::v-deep .price .help-text {
            font-size: 0.6em;
            line-height: 1em;
            display: block;
            width: 100%;
            text-align: center;
            position: static;
        }
    }

    &--dense {
        #{$self}__price {
            height: $price-height-dense;
        }

        #{$self}__title {
            min-height: $price-height-dense;
        }

        #{$self}__subtitle {
            margin-top: 0;
        }
    }

    &__hint {
        display: flex;
    }

    &:hover,
    &--active {
        border-color: var(--product-select-variant-active-color, var(--primary));
        z-index: 1;

        #{$self}__price {
            background-color: var(--product-select-variant-active-color, var(--primary));
			color: var(--product-select-variant-price-active-color, var(--product-select-variant-price-color));
        }

        #{$self}__hint {
            color: var(--product-select-variant-active-color, var(--primary));
        }
    }
}
</style>
